<div class="px-3 pt-3">
  <mat-card>
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="store.data$()"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        [customColumnDef]="[{ name: 'name', template: nameCell, isSortable: true }]"
        (deleteClick)="initializeDelete()"
        (editClick)="initializeEdit()"
        (addClick)="initializeAdd()"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
      />
    </mat-card-content>
  </mat-card>
</div>

<ng-template #nameCell let-row="row">
  <div class="d-flex align-items-center">
    <span (click)="openColumns(row)">
      <mat-icon class="link-button v-middle pe-1">view_kanban</mat-icon>
      <span class="link-button">{{
        row.isDefault ? ('page.kanbanConfig.defaultViewName' | translate) : row.name
      }}</span>
    </span>

    <mat-chip *ngIf="row.isDefault" class="ms-2" selectable="false">
      {{ 'system.label.default' | translate | uppercase }}
    </mat-chip>
  </div>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
